<!--
员工管理
-->
<template>
	<div class="box-page">
		<div class="flex-c-s mb20">
			<div class="box-title">员工管理</div>
			<div class="box-btn" v-if="btns['add-employees']" @click="addUser">
				<img src="@/assets/images/btn_add_icon.png" width="13" height="13" />
				<span>新增员工</span>
			</div>
		</div>

		<div class="flex mb20">
			<el-input v-model="keyword" placeholder="请输入搜索关键字" clearable style="width: auto; margin-right: 20px"
				@clear="getUserList"></el-input>
			<el-button type="primary" @click="getUserList">搜索</el-button>
		</div>

		<div class="my-table" v-loading="loading">
			<el-table :data="list" width="100%">
				<el-table-column label="姓名" prop="userName" width="150" show-overflow-tooltip>
					<template slot-scope="scope">
						<div class="flex-col-center">
							<img class="row-header" :src="scope.row.avatar" />
							<span>{{ scope.row.userName }}</span>
						</div>
					</template>
				</el-table-column>
				<el-table-column prop="account" label="电话" show-overflow-tooltip>
				</el-table-column>
				<el-table-column prop="roleName" label="角色" show-overflow-tooltip>
				</el-table-column>
				<el-table-column prop="deptName" label="所属部门" show-overflow-tooltip>
					<template slot-scope="scope">
						<span>{{ scope.row.deptName.join(',') }}</span>
					</template>
				</el-table-column>
				<el-table-column prop="status" label="状态" show-overflow-tooltip>
					<template slot-scope="scope">
						<span :style="
                scope.row.status == '0' ? 'color:#67C23A' : 'color:#DA9737'
              ">{{ scope.row.status == 0 ? '启用' : '禁用' }}</span>
					</template>
				</el-table-column>
				<el-table-column prop="loginTime" label="登录时间" show-overflow-tooltip>
				</el-table-column>
				<el-table-column label="操作" width="140">
					<template slot-scope="scope">
						<div class="row-btns">
							<el-tooltip class="item" effect="dark" content="编辑" placement="top">
								<img src="@/assets/images/yggl_icon_bj.png" @click="showUpdate(scope.row.userId)"
								v-if="btns['update-employees']" />
							</el-tooltip>
							<el-tooltip class="item" effect="dark" content="修改密码" placement="top">
								<img src="@/assets/images/yggl_icon_xgmm.png" @click="showPwd(scope.row.userId)"
								v-if="btns['update-pwd']" />
							</el-tooltip>
							<el-tooltip class="item" effect="dark" content="删除" placement="top">
								<img src="@/assets/images/yggl_icon_sc.png" @click="showDel(scope.row.userId)"
								v-if="btns['del-employees']" />
							</el-tooltip>
						</div>
					</template>
				</el-table-column>
			</el-table>

			<el-pagination background layout="prev, pager, next" :total="total" :current-page.sync="page"
				class="box-paging" @current-change="getUserList">
			</el-pagination>
		</div>

		<el-dialog :title="dialogTitle" :visible.sync="visible" :close-on-click-modal="false"
			:width="dialogType == 2 ? '30%' : '40%'" @close="changeClose" v-el-drag-dialog>
			<!-- 编辑 -->
			<el-form :model="updateForm" label-width="100px" label-position="left" class="my-form" :rules="updateRules"
				ref="updateRef" v-loading="dialogLoading" v-show="dialogType == 1 || dialogType == 3">
				<el-form-item label="员工姓名:" prop="userName">
					<el-input v-model="updateForm.userName" placeholder="请输入员工姓名"></el-input>
				</el-form-item>
				<el-form-item label="账户手机号:" prop="account">
					<el-input v-model="updateForm.account" placeholder="请输入账户手机号"></el-input>
				</el-form-item>
				<el-form-item label="员工工号:" prop="number">
					<el-input v-model="updateForm.number" placeholder="请输入员工工号"></el-input>
				</el-form-item>
				<el-form-item label="员工邮箱：" prop="email">
					<el-input v-model="updateForm.email" placeholder="请输入员工邮箱"></el-input>
				</el-form-item>
				<el-form-item label="初始密码:" prop="password" v-if="dialogType == 3">
					<el-input v-model="updateForm.password" show-password placeholder="请输入初始密码"></el-input>
				</el-form-item>
				<el-form-item label="账号状态：" :class="{ 'my-radio': updateForm.status == 1 }" prop="status">
					<el-radio-group v-model="updateForm.status">
						<el-radio-button label="0">启用</el-radio-button>
						<el-radio-button label="1">停用</el-radio-button>
					</el-radio-group>
				</el-form-item>
				<el-form-item label="选择部门:" prop="deptId">
					<el-cascader v-model="updateForm.deptId" :options="deptList" :props="{
              multiple: true,
              checkStrictly: true,
              label: 'deptName',
              value: 'deptId',
              children: 'nextDeptList',
            }" :show-all-levels="false" clearable style="width: 100%" ref="cascader"></el-cascader>
				</el-form-item>
				<el-form-item label="选择角色:" prop="roleId">
					<el-select v-model="updateForm.roleId" placeholder="请选择角色" style="width: 100%">
						<el-option v-for="item in roleList" :key="item.roleId" :label="item.roleName"
							:value="item.roleId">
						</el-option>
					</el-select>
				</el-form-item>
				<div class="flex-row-center">
					<div class="box-btn" style="width: 290px" @click="handleAdd" v-if="dialogType == 3">
						确认新增
					</div>
					<div class="box-btn" style="width: 290px" @click="confirmUpdate" v-else-if="dialogType == 1">
						确认修改
					</div>
				</div>
			</el-form>

			<!-- 密码 -->
			<el-form :model="pwdForm" :rules="pwdRules" ref="pwdRef" v-loading="dialogLoading" v-show="dialogType == 2">
				<el-form-item prop="nowPwd">
					<el-input v-model="pwdForm.nowPwd" show-password placeholder="请输入新密码"></el-input>
				</el-form-item>
				<el-form-item prop="confirmPwd">
					<el-input v-model="pwdForm.confirmPwd" show-password placeholder="请再次输入密码"></el-input>
				</el-form-item>
				<div class="flex-row-center">
					<div class="box-btn" style="width: 290px" @click="updatePwd">
						确认修改
					</div>
				</div>
			</el-form>
		</el-dialog>
	</div>
</template>

<script>
	import {
		checkEmail
	} from '@/utils/valid'

	export default {
		components: {},
		data() {
			const validatePass = (rule, value, callback) => {
				if (value !== this.pwdForm.nowPwd) {
					callback(new Error('两次输入密码不一致!'))
				} else {
					callback()
				}
			}
			const validatorEmail = (rule, value, callback) => {
				if (!checkEmail.test(value)) {
					callback(new Error('邮箱格式不正确!'))
				} else callback()
			}
			return {
				keyword: '', // 搜索关键字
				list: [],
				page: 1,
				total: 1,
				loading: false,

				visible: false,
				dialogType: null, // 1 编辑 2 修改密码 3 新增
				dialogTitle: '',
				dialogLoading: false,

				nowUserId: '', // 当前点击操作的员工id

				roleList: [], // 角色列表
				deptList: [], // 部门列表
				formatDeptList: [], // 格式化部门列表

				// 编辑  新增 表单
				updateForm: {
					userName: '',
					account: '',
					number: '',
					email: '',
					password: '',
					status: '0',
					deptId: [],
					roleId: ''
				},

				// 密码表单
				pwdForm: {
					nowPwd: '',
					confirmPwd: ''
				},

				updateRules: {
					userName: {
						required: true,
						message: '请输入员工姓名',
						trigger: 'blur'
					},
					account: {
						required: true,
						message: '请输入账户手机号',
						trigger: 'blur'
					},
					number: {
						required: true,
						message: '请输入员工工号',
						trigger: 'blur'
					},
					email: [{
							required: true,
							message: '请输入客户邮箱',
							trigger: 'blur'
						},
						{
							validator: validatorEmail,
							trigger: 'blur'
						}
					],
					password: {
						required: true,
						message: '请输入初始密码',
						trigger: 'blur'
					},
					status: {
						required: true,
						message: '请选择账号状态',
						trigger: 'change'
					},
					deptId: {
						required: true,
						message: '请选择部门',
						trigger: 'change'
					},
					roleId: {
						required: true,
						message: '请选择角色',
						trigger: 'change'
					}
				},

				pwdRules: {
					nowPwd: {
						required: true,
						message: '请输入密码',
						trigger: 'blur'
					},
					confirmPwd: [{
							required: true,
							message: '请输入再次输入密码',
							trigger: 'blur'
						},
						{
							validator: validatePass,
							trigger: 'blur'
						}
					]
				}
			}
		},
		computed: {
			// 按钮权限
			btns() {
				return this.$route.meta.btns
			}
		},
		watch: {},
		mounted() {
			this.getUserList()
			this.getRoleList()
			this.getDeptList()
		},
		methods: {
			// 获取员工列表
			getUserList() {
				this.loading = true
				this.$api.organization
					.userList({
						keyword: this.keyword,
						limit: 10,
						page: this.page
					})
					.then(({
						data
					}) => {
						this.loading = false
						if (data.code == 200) {
							this.list = data.data
							this.total = data.total
						}
					})
					.catch(() => {
						this.loading = false
					})
			},

			// 新增员工
			addUser() {
				this.dialogType = 3
				this.dialogTitle = '新增员工'
				this.visible = true
			},

			// 确认新增
			handleAdd() {
				this.$refs.updateRef.validate((valid) => {
					if (valid) {
						this.dialogLoading = true
						const nodes = this.$refs.cascader.getCheckedNodes()
						const deptId = nodes.map((item) => item.value) // 获取所选部门id集合

						this.$api.organization
							.addUser({
								...this.updateForm,
								deptId
							})
							.then(({
								data
							}) => {
								this.dialogLoading = false
								if (data.code == 200) {
									this.visible = false
									this.$notify.success({
										title: '提示',
										message: '新增成功'
									})
									this.getUserList()
								}
							})
							.catch(() => {
								this.dialogLoading = false
							})
					} else return false
				})
			},

			// 编辑
			showUpdate(id) {
				this.visible = true
				this.dialogType = 1
				this.dialogTitle = '编辑员工'
				this.dialogLoading = true
				this.$api.organization
					.userDetail(id)
					.then(({
						data
					}) => {
						this.dialogLoading = false
						if (data.code == 200) {
							const deptId = []
							this.formatDeptList.forEach((item) => {
								if (data.data.deptId.indexOf(item.deptId) !== -1) {
									deptId.push(item.formatId)
								}
							})

							this.updateForm = {
								...data.data,
								deptId
							}
						}
					})
					.catch(() => {
						this.dialogLoading = false
					})
			},

			// 确认编辑
			confirmUpdate() {
				this.$refs.updateRef.validate((valid) => {
					if (valid) {
						const nodes = this.$refs.cascader.getCheckedNodes()
						const deptId = nodes.map((item) => item.value) // 获取所选部门id集合
						// let deptPath = nodes.map((item) => item.path) // 获取所选部门path合集 用于回显
						this.dialogLoading = true

						this.$api.organization
							.editUser({
								...this.updateForm,
								deptId
								// deptPath: JSON.stringify(deptPath),
							})
							.then(({
								data
							}) => {
								this.dialogLoading = false
								if (data.code == 200) {
									this.$notify.success({
										title: '提示',
										message: '修改成功'
									})
									this.visible = false
									this.getUserList()
								}
							})
							.catch(() => {
								this.dialogLoading = false
							})
					} else return false
				})
			},

			// 修改密码
			showPwd(id) {
				this.visible = true
				this.dialogType = 2
				this.dialogTitle = '修改密码'
				this.nowUserId = id
			},

			// 确认修改密码
			updatePwd() {
				this.$refs.pwdRef.validate((valid) => {
					if (valid) {
						this.dialogLoading = true

						this.$api.organization
							.editUser({
								userId: this.nowUserId,
								password: this.pwdForm.confirmPwd
							})
							.then(({
								data
							}) => {
								this.dialogLoading = false
								if (data.code == 200) {
									this.$notify.success({
										title: '提示',
										message: '修改成功'
									})
									this.visible = false
									this.getUserList()
								}
							})
							.catch(() => {
								this.dialogLoading = false
							})
					} else return false
				})
			},

			// 删除
			showDel(id) {
				this.$confirm('此操作将删除该员工信息, 是否继续?', '提示', {
						confirmButtonText: '确定',
						cancelButtonText: '取消',
						type: 'warning'
					})
					.then(() => {
						this.$api.organization.delUser(id).then(({
							data
						}) => {
							if (data.code == 200) {
								if (this.total % 10 == 1 && this.page != 1) this
									.page-- // 若当前删除的为当前页最后一个 则page-1
								this.$notify.success({
									title: '提示',
									message: '删除成功'
								})
								this.getUserList()
							}
						})
					})
					.catch(() => {})
			},

			changeClose() {
				this.$refs.updateRef.resetFields()
				this.$refs.pwdRef.resetFields()
			},

			// 获取角色列表
			getRoleList() {
				this.$api.organization
					.roleList({
						page: 1,
						limit: -1,
						keyword: ''
					})
					.then(({
						data
					}) => {
						if (data.code == 200) {
							this.roleList = data.data
						}
					})
			},

			// 获取部门列表
			getDeptList() {
				this.$api.organization
					.deptList({
						keyword: '',
						limit: -1,
						page: 1
					})
					.then(({
						data
					}) => {
						if (data.code == 200) {
							this.deptList = data.data
							this.getFormatDeptList(data.data)
						}
					})
			},

			// 获取格式化的部门列表-回显使用
			getFormatDeptList(list, father = []) {
				list.forEach((item) => {
					item.formatId = [...father, item.deptId]
					this.formatDeptList.push(item)
					if (item.nextDeptList && item.nextDeptList.length > 0) {
						this.getFormatDeptList(item.nextDeptList, item.formatId)
					}
				})
			}
		}
	}
</script>
<style lang="scss" scoped>
	.my-form /deep/.el-form-item__label {
		color: #666;
	}

	.my-radio /deep/ .el-radio-button__orig-radio:checked+.el-radio-button__inner {
		background-color: red;
		border-color: red;
		box-shadow: -1px 0 0 0 red;
	}
</style>
